var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDataFailed = function SvgDataFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 107 105"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "#DEE2E6",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M53.816 103.02c28 0 50.7-22.7 50.7-50.8 0-28.1-22.8-50.8-50.7-50.8-28 0-50.7 22.7-50.7 50.8 0 28.1 22.7 50.8 50.7 50.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#DEE2E6",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M102.128 25.537v58.837c0 1.727-1.439 3.165-3.165 3.165H9.555c-1.726.072-3.164-1.366-3.164-3.093v-58.91a3.147 3.147 0 0 1 3.164-3.164h89.408a3.147 3.147 0 0 1 3.165 3.165Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#DEE2E6",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M102.128 25.537v4.531H6.391v-4.531a3.147 3.147 0 0 1 3.164-3.165h89.408a3.147 3.147 0 0 1 3.165 3.165Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9B3BD",
    d: "M10.635 27.55a1.079 1.079 0 1 0 0-2.157 1.079 1.079 0 0 0 0 2.158M14.016 27.55a1.079 1.079 0 1 0 0-2.157 1.079 1.079 0 0 0 0 2.158M17.468 27.55a1.079 1.079 0 1 0 0-2.157 1.079 1.079 0 0 0 0 2.158"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2E6",
    stroke: "#A9B3BD",
    strokeMiterlimit: 10,
    strokeWidth: 1.385,
    d: "M71.647 61.666a22.693 22.693 0 0 1-1.64 4.666c-1.829 3.405-4.54 6.18-7.945 7.882-3.531 1.829-7.693 2.46-11.917 1.64-9.837-2.081-16.206-11.666-14.125-21.566 2.081-9.9 11.602-16.268 21.502-14.187 3.531.757 6.621 2.46 9.206 4.918a18.667 18.667 0 0 1 4.919 16.647Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#A9B3BD",
    strokeWidth: 1.385,
    d: "M50.574 49.408v.013l.946 10.205c.092 1.373 1.278 2.467 2.645 2.467 1.366 0 2.553-1.094 2.645-2.467l.945-10.205v-.015c.155-2.166-1.486-3.894-3.59-3.894-2.113 0-3.746 1.8-3.591 3.896ZM54.165 63.985a2.953 2.953 0 0 0-2.962 2.962 2.953 2.953 0 0 0 2.962 2.962 2.953 2.953 0 0 0 2.962-2.962 2.953 2.953 0 0 0-2.962-2.962Z"
  })));
};
export default SvgDataFailed;